import {Mutable, template as tpl} from "./mutable";
import {IExportAttribute, IExportFlow, IExportTemplate, IRouteDefinitionParams} from "../../index";
import {_} from 'lodash';
import PromiseRequest from "../../req/PromiseRequest";
import {nsExportTemplate} from "./fn";
import {global} from "../../appContext";
import {createErrorMessage, normalizeObjectType} from "../../util/misc";
import {UPDATING_MESSAGE} from "../../constants/Language";
import Section = nsExportTemplate.Section;
import {nsParentPath} from "./parentpath/fn";
import {IRequestObject} from "../../req/index";

export let template: string = tpl;

export class viewModel extends Mutable {
    protected icon = 'fa-pencil';
    protected label = "Endre synkroniseringsmal";

    protected override submitRequestMessage: string = UPDATING_MESSAGE
    protected override submitSuccessMessage: string = `subject is updated|s:((synchronization template))`;
    protected reqSubmit: PromiseRequest = global.getPromiseRequest("updateexporttemplate");
    private reqobj_getexportattributes!: IRequestObject<IExportAttribute[]>;

    constructor(params: IRouteDefinitionParams) {
        super(params);

        this.initRequest()
            .then(() => this.__requestRouteData?.request())
            .then((data: IExportTemplate[] | undefined) => {
                const loaded = data?.[0];
                if (!loaded) {
                    return;
                }
                const d = _.cloneDeep(loaded);
                this.normalizeExportTemplate(d);

                this.data.$original = _.cloneDeep(d);
                this.data.active(d.active);
                this.data.daysbeforepermanentdelete(d.daysbeforepermanentdelete);
                this.data.deletefiles(d.deletefiles);
                this.data.description(d.description);
                this.data.name(d.name);
                const objectType = this.availableObjectTypes.find(o => o.id == d.objecttype.id);
                if (objectType) {
                    this.data.objecttype(objectType);
                }
                this.data.ruleset(d.ruleset);
                this.data.syncstep(d.syncstep);

                // Hydrate export flows after both objecttype and syncstep are set (objecttype is not editable here).
                if (!objectType || !d.syncstep) {
                    return;
                }
                this.reqobj_getexportattributes?.promise.abort();
                this.reqobj_getexportattributes = nsExportTemplate.getExportAttributes(d.syncstep.syncstep.id, objectType.id);
                return this.reqobj_getexportattributes.request.then((attributes: IExportAttribute[]) => {
                    const exportflows = this.data.$original.exportflow.map(flow => nsExportTemplate.exportFlowToMutable(flow, attributes));
                    exportflows
                        .filter(flow => nsExportTemplate.isExportFlowMutableParentPath(flow))
                        .forEach(flow => flow.type(nsParentPath.getType(flow.expression(), flow.sourceattribute())));
                    exportflows.forEach(flow => this.trackFlowErrors(flow));
                    this.data.exportflow(exportflows);
                });
            })
            .then(() => this.onSuccess())
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }

    protected override showEdit(section: Section): boolean {
        switch (section) {
            case Section.ObjectType:
                return false
            default:
                return super.showEdit(section)
        }
    }

    // TODO: this shouldn't be necessary.
    // This fixes bugs in the API where the object type ids are incorrect.
    private normalizeExportTemplate(data: IExportTemplate) {
        normalizeObjectType(data.objecttype);
        data.exportflow.forEach((ef: IExportFlow) => {
            if (ef.objecttype) {
                normalizeObjectType(ef.objecttype);
            }
        });
    }

    override dispose() {
        super.dispose();
        this.reqobj_getexportattributes?.promise.abort()
    }

}
